/** Admin area. */
export default {
  title: "Admin",
  lead: "Desk operations: people, money, risk and the platform itself.",
  mfaGate: "The admin area needs two-step verification. Add a second factor in Security, then sign in again if asked.",
  toSecurity: "Open Security",
  tabs: {
    users: "Users",
    audit: "Audit log",
    settings: "Settings",
    jobs: "Jobs",
    errors: "Errors",
    data: "Data health",
  },
  common: {
    search: "Search",
    reason: "Reason (written to the audit log)",
    save: "Save",
    cancel: "Cancel",
    empty: "Nothing here yet",
    loadMore: "Load more",
    actions: "Actions",
  },
  users: {
    searchPlaceholder: "E-mail, name or @telegram",
    email: "E-mail",
    telegramOnly: "Telegram only",
    name: "Name",
    roles: "Roles",
    status: "Status",
    mfa: "2FA",
    lastLogin: "Last sign-in",
    active: "Active",
    blocked: "Blocked",
    block: "Block",
    unblock: "Unblock",
    signOut: "Sign out everywhere",
    editRoles: "Roles",
    rolesHint: "Needs a superadmin with a security key. The user is signed out to apply new roles.",
  },
  audit: {
    action: "Action",
    actor: "Who",
    target: "Target",
    when: "When",
    reason: "Reason",
    verify: "Verify the hash chain",
    chainOk: { one: "Chain intact: {count} record checked", other: "Chain intact: {count} records checked" },
    chainBroken: "Chain broken at record {id}",
    filterAction: "Action starts with",
  },
  settings: {
    default: "default",
    changed: "Changed by {who}, {when}",
    saved: "Saved",
  },
  jobs: {
    name: "Job",
    last: "Last run",
    status: "Status",
    lastOk: "Last success",
    failures: "Failures 24 h",
    none: "No runs yet: jobs run in the worker process.",
  },
  data: {
    instrument: "Instrument",
    source: "Source",
    status: "Status",
    book: "Book",
    age: "Quote age",
    lag: "Lag",
    resyncs: "Resyncs",
    adapters: "Sources",
    connected: "connected",
    disconnected: "disconnected",
    reconnects: { one: "{count} reconnect", other: "{count} reconnects" },
    live: "Live",
    closed: "Closed (outside session)",
    noData: "No data",
    replay: "REPLAY",
    reasons: { syncing: "syncing", stale: "stale", resyncing: "resyncing", no_data: "no data source" },
    unavailable: "md-gateway is not answering.",
  },
  roles: {
    trader: "Trader",
    affiliate: "Affiliate",
    support: "Support",
    risk_analyst: "Risk analyst",
    risk_manager: "Risk manager",
    payments_operator: "Payments operator",
    payments_approver: "Payments approver",
    compliance: "Compliance",
    product_admin: "Product admin",
    finance: "Finance",
    superadmin: "Superadmin",
  },
  settingKeys: {
    marketData_staleMsCrypto: "Stale quote limit, crypto",
    marketData_staleMsFx: "Stale quote limit, FX/CFD",
    marketData_staleMsFutures: "Stale quote limit, futures",
    payouts_newAddressDelayHours: "Payout delay for a new wallet",
    payouts_reserveRatio: "Payout reserve per sale (share of the price)",
    risk_breachReviewHours: "Review window after a breach",
    risk_fundingCapPerPersonUsd: "Funded capital per trader, all programs",
    payouts_cryptoAddressTtlMinutes: "Crypto deposit address lifetime",
    payouts_checkoutTtlMinutes: "Card checkout lifetime",
    payouts_cryptoConfirmations: "Crypto confirmations required",
    payouts_underpayTolerancePct: "Crypto underpayment tolerance",
    payouts_affiliateRatePct: "Default affiliate commission",
    payouts_withdrawalMinUsd: "Smallest withdrawal of the balance",
    payouts_withdrawalFeeTronUsd: "Withdrawal network fee, TRON",
    payouts_withdrawalFeeEthereumUsd: "Withdrawal network fee, Ethereum",
    offers_bonusActivationPct: "Bonus activation fee without Turbo (share of the price paid)",
    offers_resetPricePct: "Reset after a breach (share of the price paid)",
    offers_breachCouponPct: "Coupon after a breach (discount on the next purchase)",
    offers_breachCouponDays: "Coupon after a breach: days it is valid",
    platform_demoBanner: "Test-mode banner on every page",
  },
  units: {
    ms: "ms",
    hours: "h",
  },
  errors: {
    message: "Error",
    count: "Count",
    lastSeen: "Last seen",
    resolve: "Mark fixed",
    showResolved: "Show fixed",
  },
} as const;
